import { parentNavigate } from "./ParentNavigate";
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';
function Breadcrumbs({ crumbs }) {
  return (
    <>
      {crumbs?.length > 0 && (
        <div className="flex flex-wrap table-text items-center w-full leading-3 text-[12px]">
          {crumbs?.map((crumb, index) => (
            <span key={index} className="inline-flex breadcrumb-item items-center">
              {index !== 0 && <p className="mx-1 leading-3 text-[12px]"> / </p>}
              {index !== crumbs.length - 1 ? (
                <ButtonComponent
                  variant="link"
                  size="sm"
                  onClick={() => parentNavigate(crumb.path)}
                  className="!text-[12px] text-[var(--table-text-color)]"
                >
                  {crumb.name}
                </ButtonComponent>
              ) : (
                crumb.name
              )}
            </span>
          ))}
        </div>
      )}
    </>
  );
}

export default Breadcrumbs;

